import { Location } from '@cobliteam/common-types';
import useVehicle from '@cobliteam/hooks/src/useEntity/useVehicle';
import { filterGetParamDates } from '@cobliteam/ui-business/components/DataTable/components/Filters';
import Page from '@cobliteam/ui-business/components/layout/Page';
import { useHistory, useParams } from 'react-router-dom';
import VehiclePathsTable from '../components/VehiclePathsTable';

const VehiclePathsPage = () => {
  const history = useHistory();

  const { vehicleId } = useParams<{ vehicleId: string }>();
  const { data: vehicle } = useVehicle().getVehicle(vehicleId, { enabled: !!vehicleId });

  const redirectToAggregatedPage = () => {
    const selectedDate = filterGetParamDates(0);
    const startDate = selectedDate.startDate;
    const endDate = selectedDate.endDate;

    const queryParams = new URLSearchParams(window.location.search);
    queryParams.append('startDate', startDate.toString());
    queryParams.append('endDate', endDate.toString());

    history.push({
      pathname: Location.PATH_ASSOCIATION,
      search: queryParams.toString(),
    });
  };

  return (
    <Page>
      <Page.BackButton label='Voltar' onClick={redirectToAggregatedPage} />

      <Page.Header>
        <Page.Title title={`Trechos ${vehicle?.licensePlate ? `- ${vehicle.licensePlate}` : ''}`} />
      </Page.Header>

      <Page.Body>
        <VehiclePathsTable />
      </Page.Body>
    </Page>
  );
};

export default VehiclePathsPage;
